import React from 'react';
import { Heading } from '../../components';

import css from './ListingPage.module.css';
import { processHeading } from '../../util/genericHelpers';
import SelectedPropertyGroup from '../../components/SelectedPropertyGroup/SelectedPropertyGroup';

const SectionMultiEnumMaybe = props => {
  const { heading, options, selectedOptions, isOwnListing } = props;
  if (!heading || !options || !selectedOptions) {
    return null;
  }

  return (
    <section className={css.sectionMultiEnum}>
      <Heading as="h2" rootClassName={css.sectionHeading}>
        {processHeading(heading)}
      </Heading>
      <SelectedPropertyGroup
        id="ListingPage.amenities"
        options={options}
        selectedOptions={selectedOptions}
        twoColumns={options.length > 5}
        isOwnListing={isOwnListing}
      />
    </section>
  );
};

export default SectionMultiEnumMaybe;
